var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title-ch":"集點功能","title-en":"POINT","breadcrumb-items":_vm.currentBreadcrumbItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }